import { strCode } from "../localizations/strCode";

const hardwareErrors = {
  INVALID_PARAMETER_PROVIDED: strCode.INVALID_PARAMETER_PROVIDED
};

export default hardwareErrors;
